import React from "react";
import CircularButton from "../CircularButton/CircularButton";

type VideoPreviewType = {
  isModalOpen: boolean;
  setIsModalOpen: (modalOpen: boolean) => void;
  backgroundImage: string;
  backgroundImageAltText: string;
  triggerAnalytics?: () => void;
};

const VideoPreview: React.FC<VideoPreviewType> = ({
  isModalOpen,
  setIsModalOpen,
  backgroundImage,
  backgroundImageAltText,
  triggerAnalytics,
}) => {
  return (
    <div className="video--preview">
      <CircularButton
        onClick={() => {
          setIsModalOpen(true);
          if (triggerAnalytics) {
            triggerAnalytics();
          }
        }}
        className={isModalOpen ? "circular-button--isOpen" : ""}
      />
      <img
        className="video--preview__image"
        src={backgroundImage}
        alt={backgroundImageAltText}
      />
    </div>
  );
};

export default VideoPreview;
